// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1__TW","cls2":"blurred_takeaways-cls2_KZ- blurred_takeaways-cls1__TW"};